import naacLogo from "../assets/img/rec/naac.webp";
import aiuLogo from "../assets/img/rec/aiu.webp";
import aacsbLogo from "../assets/img/rec/aacsb.png";
import ugcLogo from "../assets/img/rec/ugc.png";
import aicteLogo from "../assets/img/rec/aicte.webp";
import bciLogo from "../assets/img/rec/bci.webp";
import pciLogo from "../assets/img/rec/pci.webp";

import { Title } from "../components/CommonComponents";

export default function Accreditations() {

    const accreditation = [
        { title: "NAAC", logo: naacLogo },
        { title: "AIU", logo: aiuLogo },
        { title: "AACSB", logo: aacsbLogo },
        { title: "UGC", logo: ugcLogo },
        { title: "AICTE", logo: aicteLogo },
        { title: "PCI", logo: pciLogo },
        { title: "BCI", logo: bciLogo },
    ];


    return (
        <section className="flex items-center overflow-hidden bg-white max-[768px]:block">
            <div className="relative z-[2] min-w-[340px] rounded-r-[90px] bg-[#8b1e3f] px-[45px] py-[55px] text-white max-[768px]:min-w-full max-[768px]:rounded-none max-[768px]:px-[25px] max-[768px]:py-[35px]">
                <Title dark>Approvals &<br /> Accreditations</Title>
            </div>
            <div className="flex-1 overflow-hidden pl-[35px] max-[768px]:px-[15px] max-[768px]:py-[30px]">
                <div className="recognition-track flex w-max animate-[scrollRecognition_30s_linear_infinite] hover:[animation-play-state:paused] motion-reduce:animate-none">
                    {[...accreditation, ...accreditation].map((item, index) => (
                        <div className="mr-[22px] flex h-[170px] w-[220px] items-center justify-center rounded-[18px] bg-[#f8f8f8] p-4 transition-all duration-[350ms] hover:-translate-y-2 hover:shadow-[0_15px_35px_rgba(0,0,0,0.12)] max-[768px]:h-[130px] max-[768px]:w-[170px]" key={index}>
                            <div className="flex h-[120px] w-[180px] items-center justify-center rounded-[14px] bg-white p-2 max-[768px]:h-[90px] max-[768px]:w-[135px]">
                                <img src={item.logo} alt={item.title} className="max-h-[100px] object-contain" />
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    )
}